import { Navbar } from "../components/site/Navbar";
import { Hero } from "../components/site/Hero";
import { FloatingCTA } from "../components/site/FloatingCTA";
import { LeadForm } from "../components/site/LeadForm";
import { TrustMarquee, About, Services, Destinations, WhyChooseUs, HowItWorks, Testimonials, FAQ, Contact, Footer } from "../components/site/Sections";

export default function Landing() {
  return (
    <div className="bg-off-white" data-testid="landing-page">
      <Navbar />
      <FloatingCTA />
      <main>
        <Hero />
        <TrustMarquee />
        <About />
        <Services />
        <Destinations />
        <WhyChooseUs />
        <HowItWorks />
        <Testimonials />
        <FAQ />
        <LeadForm />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
